import '../components/towersMap.js';
require('./home-mobile/modules/contato-dropdown');
document.addEventListener('DOMContentLoaded', () => {
  window.HomeContatoDropdown?.init();
  setupTerrainDprObserver();
});


function home3ScrollCfg(extra) {
  var base = {};
  if (window.lenis) base.scroller = document.documentElement;
  if (!extra) return base;
  for (var k in extra) base[k] = extra[k];
  return base;
}

/**
 * Reajusta os atributos width/height físicos do SVG do terreno quando
 * o devicePixelRatio muda (zoom OS/navegador). Não toca em CSS — o
 * tamanho visual continua governado por width: clamp(...) no SCSS.
 * stroke-width fica intocado: o path usa vector-effect="non-scaling-stroke".
 */
function setupTerrainDprObserver() {
  var svg = document.querySelector('.location__terrain');
  if (!svg) return;

  function apply() {
    var dpr = window.devicePixelRatio || 1;
    var rect = svg.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    svg.setAttribute('width', Math.round(rect.width * dpr));
    svg.setAttribute('height', Math.round(rect.height * dpr));

    var mq = window.matchMedia('(resolution: ' + dpr + 'dppx)');
    mq.addEventListener('change', apply, { once: true });
  }

  apply();
  window.addEventListener('resize', apply, { passive: true });
}

/** Troca vídeos para URLs mobile antes do preloader — evita play() no desktop e swap depois sem novo play(). */
function applyHome3MobileVideoSources() {
  if (window.innerWidth > 768) return;
  document.querySelectorAll('#home3 video[data-src-mobile]').forEach(function (v) {
    var mobileSrc = v.dataset.srcMobile;
    if (mobileSrc) {
      v.src = mobileSrc;
      v.removeAttribute('data-src-mobile');
      v.load();
    }
  });
}

/** Inline vence o CSS crítico (home3-critical: html/main overflow hidden). String vazia deixava o hidden do stylesheet. */
function unlockHome3ScrollAfterPreload() {
  document.documentElement.style.overflow = 'auto';
  var mainEl = document.getElementById('main');
  if (mainEl) mainEl.style.overflowY = 'visible';
}

window.addEventListener('load', function () {

      document.documentElement.style.overflow = 'hidden';
      if (window.lenis) window.lenis.stop();
      applyHome3MobileVideoSources();


      function setProgress(loaded, total) {
        /* home3: sem contador percentual */
      }

      function revealPage() {
        var loader = document.querySelector('.home-loader');

        // Inicializa GSAP states ANTES do preloader sumir
        // para que nenhuma seção apareça durante o fade-out.
        // A timeline de entrada fica pausada e é retomada no onComplete.
        var entryTl = initApp();

        if (typeof gsap !== 'undefined' && loader) {
          gsap.to(loader, {
            opacity: 0,
            duration: 0.8,
            ease: 'power2.out',
            onComplete: function () {
              loader.classList.add('hidden');
              loader.style.display = 'none';
              unlockHome3ScrollAfterPreload();
              if (window.lenis) window.lenis.start();
              if (entryTl) entryTl.play();
            }
          });
        } else {
          if (loader) loader.style.display = 'none';
          unlockHome3ScrollAfterPreload();
          if (window.lenis) window.lenis.start();
          if (entryTl) entryTl.play();
        }
      }

      function initApp() {
        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
          console.error('[home3] GSAP / ScrollTrigger ausentes');
          return null;
        }
        gsap.registerPlugin(ScrollTrigger);
        var IS_MOBILE = window.innerWidth <= 768;
        // Lenis: usa window.lenis (main.js / scrollLenis)
        var lenis = window.lenis;

        var heroVideo     = document.getElementById('heroVideo');
      var locationVideo = document.getElementById('locationVideo');
      var lifestyleVideo = document.getElementById('lifestyleVideo');
      var spaceVideo         = document.getElementById('spaceVideo');
      var arquiteturaVideo     = document.getElementById('arquiteturaVideo');
      var luxoVideo            = document.querySelector('#silence .luxo__video');
      var galeriaVideos        = Array.from(document.querySelectorAll('.galeria__slide video'));
      var heroSection   = document.getElementById('hero');

      // ===== PERFORMANCE: Ciclo de vida dos vídeos =====
      // Toda a lógica de play/pause é controlada por scroll progress (onUpdate)
      // e pelos eventos de pin (onLeave/onEnterBack) — ver ScrollTrigger.create().
      // O IntersectionObserver cuida apenas do caso extremo: usuário scrollou
      // para além do hero depois do pin terminar.
      var _observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) {
          if (heroVideo)     heroVideo.pause();
          if (locationVideo)  locationVideo.pause();
          if (lifestyleVideo) lifestyleVideo.pause();
          if (spaceVideo)    spaceVideo.pause();
        }
      }, { threshold: 0.01 });
      _observer.observe(heroSection);

      // Ciclo de vida dos vídeos da seção #silence (arquitetura + galeria)
      // Fallback de segurança: pausa quando a seção sai totalmente do viewport
      var _silenceObserver = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) {
          if (luxoVideo) luxoVideo.pause();
          if (arquiteturaVideo) arquiteturaVideo.pause();
          galeriaVideos.forEach(function (v) { v.pause(); });
        } else {
          if (luxoVideo) luxoVideo.play().catch(function () {});
        }
      }, { threshold: 0.01 });
      var silenceSection = document.getElementById('silence');
      if (silenceSection) _silenceObserver.observe(silenceSection);

      // Galeria: pausa só quando a section sai totalmente do viewport,
      // para que o último slide não congele enquanto ainda está visível.
      var _galeriaObserver = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) {
          galeriaVideos.forEach(function (v) { v.pause(); });
        }
      }, { threshold: 0 });
      var galeriaSectionEl = document.getElementById('galeria-section');
      if (galeriaSectionEl) _galeriaObserver.observe(galeriaSectionEl);

      (function initHome3TailVideos() {
        var isMobile = window.innerWidth <= 768;
        document.querySelectorAll('#home3 video[data-src]').forEach(function (v) {
          var src = isMobile ? (v.dataset.srcMobile || v.dataset.src) : v.dataset.src;
          if (src && !v.getAttribute('src')) {
            v.src = src;
            v.load();
            v.play().catch(function () {});
          }
        });
      })();

      // ===== ESTADOS INICIAIS =====
      // hero__bg-video e hero__overlay já estão visíveis antes do reveal
      // (preparados em preloadAssets para transição seamless do preloader)
      gsap.set('#header',         { opacity: 0 });
      gsap.set('#header .header-logo img',       { opacity: 0, scale: 0.9 });
      gsap.set('#header .nav-link',       { opacity: 0, y: -20 });
      gsap.set('#header .social-icons',     { opacity: 0, x: 20 });
      // Novo hero — todos elementos começam ocultos; revelados pela timeline de entrada
      gsap.set('.hero__slogan',          { opacity: 0, x: -20 });
      gsap.set('.hero__slogan-line',     { scaleX: 0, transformOrigin: 'left center' });
      gsap.set('.hero__kicker',          { opacity: 0, y: 10 });
      gsap.set('.hero__title-word',      { yPercent: 105, opacity: 0 });
      gsap.set('.hero__title-sub',       { opacity: 0, y: 10 });
      gsap.set('.hero__divider',         { opacity: 0, scaleX: 0, transformOrigin: 'left center' });
      gsap.set('.hero__cta',             { opacity: 0, y: 14 });
      gsap.set('.hero__right-panel',     { opacity: 0, x: 30 });
      gsap.set('.hero__stats',           { opacity: 0, x: 20 });
      gsap.set('.hero__marquee',         { opacity: 0, y: 20 });
      gsap.set('.hero__scroll',          { opacity: 0 });
      gsap.set('.statement-line',       { opacity: 0, y: 30 });
      // autoAlpha = opacity + visibility:hidden → browser pula compositing da subárvore inteira
      gsap.set('.location',             { autoAlpha: 0 });
      gsap.set('.location__card',       { autoAlpha: 0, y: 260, scale: 0.96 });
      gsap.set('.location__terrain',    { autoAlpha: 0, scale: 0.94, transformOrigin: 'center center' });
      var terrainPath = document.getElementById('terrainPath');
      if (terrainPath && typeof terrainPath.getTotalLength === 'function') {
        // Buffer de 5% no dash pra cobrir qualquer discrepância entre
        // getTotalLength() (unidades do path) e o stroke-dasharray renderizado
        // sob vector-effect="non-scaling-stroke" — sem buffer, o último
        // pedacinho do traço fica fora do segmento "draw" quando offset=0.
        var terrainPathLength = terrainPath.getTotalLength() * 1.05;
        gsap.set(terrainPath, { strokeDasharray: terrainPathLength, strokeDashoffset: terrainPathLength });
      }
      gsap.set('.location__pin',        { autoAlpha: 0, y: 18, scale: 0.82, transformOrigin: 'center bottom' });
      gsap.set('.location__map-tag',    { autoAlpha: 0, y: 28, scale: 0.9, transformOrigin: 'center center' });
      gsap.set('.lifestyle',            { autoAlpha: 0 });
      gsap.set('.lifestyle__bg-video',  { scale: 1.12 });
      gsap.set('.lifestyle__title',     { autoAlpha: 0, y: 34 });
      gsap.set('.lifestyle__description', { autoAlpha: 0, y: 28 });
      gsap.set('.lifestyle__highlights',  { autoAlpha: 0, y: 24 });
      gsap.set('.hero__white',             { autoAlpha: 0 });
      gsap.set('.space',               { autoAlpha: 0 });
      if (IS_MOBILE) {
        gsap.set('.space__image',        { autoAlpha: 0 });
        gsap.set('.space__content',      { autoAlpha: 0 });
      } else {
        gsap.set('.space__image',        { y: '100%' });
        gsap.set('.space__content',      { y: '100%' });
      }
      gsap.set('.space__vector',         { autoAlpha: 0, scale: 0.92 });
      document.querySelectorAll('.space__vector path').forEach(function (path) {
        var len = path.getTotalLength();
        gsap.set(path, { strokeDasharray: len, strokeDashoffset: len });
      });
      gsap.set('.space__title',          { autoAlpha: 0, y: IS_MOBILE ? 15 : 30 });
      gsap.set('.space__text',           { autoAlpha: 0, y: IS_MOBILE ? 15 : 22 });

      gsap.set('#sobre.funciona-section',           { autoAlpha: 1 });
      gsap.set('#sobre .funciona-section__decoration', { autoAlpha: 0, y: 30 });
      gsap.set('#sobre .funciona-section__title',     { autoAlpha: 0, y: 30 });
      gsap.set('#sobre .funciona-section__description', { autoAlpha: 0, y: 22 });
      gsap.set('#sobre .funciona-section__card',     { autoAlpha: 0, y: 22 });
      gsap.set('#sobre .funciona-section__btn',      { autoAlpha: 0, y: 22 });
      gsap.set('#sobre .funciona-section__highlight', { autoAlpha: 0, y: 22 });

      gsap.set('.moving-content',             { y: 80, opacity: 0 });
      gsap.set('.content-behind',             { opacity: 0, scale: 1 });
      // Luxo dentro do #silence — animados pelo zoomTl (os de #luxo-pin já iniciam visíveis)
      gsap.set('#silence .luxo__text',        { opacity: 0, y: 40 });
      gsap.set('#silence .luxo__highlight',   { opacity: 0, y: 40 });
      // Luxo-pin overlay + arquitetura
      gsap.set('.luxo-pin__overlay',          { opacity: 0 });
      if (IS_MOBILE) {
        gsap.set('.arquitetura__image',       { autoAlpha: 0 });
        gsap.set('.arquitetura__content',     { autoAlpha: 0 });
      } else {
        gsap.set('.arquitetura__image',       { y: '100%' });
        gsap.set('.arquitetura__content',     { y: '100%' });
      }
      gsap.set('.arquitetura__title',         { autoAlpha: 0, y: IS_MOBILE ? 15 : 30 });
      gsap.set('.arquitetura__text',          { autoAlpha: 0, y: IS_MOBILE ? 15 : 22 });
      gsap.set('.arquitetura__logo',          { autoAlpha: 0, y: IS_MOBILE ? 15 : 22 });
      gsap.set('.towers-map-container',       { autoAlpha: 0 });
      gsap.set('.towers-nav__item',           { autoAlpha: 0, y: 20 });

      // ===== ANIMAÇÃO DE ENTRADA =====
      // Criada PAUSADA — revealPage() dá play após o preloader sumir
      var tl = gsap.timeline({
        paused: true,
        defaults: { ease: 'power2.inOut' },
        onComplete: setupScrollAnimations
      });

      // Reveal sequence — slogan/kicker primeiro, título palavra-a-palavra (curtain),
      // depois sub, divider, CTA, right panel, stats, marquee, scroll hint
      tl
        .to('#header',                   { opacity: 1, duration: 0.6 }, 0)
        .to('#header .header-logo img',  { opacity: 1, scale: 1, duration: 0.6 }, 0)
        .to('#header .nav-link',         { opacity: 1, y: 0, duration: 0.5, stagger: 0.07, ease: 'power2.out' }, 0.05)
        .to('#header .social-icons',     { opacity: 1, x: 0, duration: 0.5 }, 0.1)
        .to('.hero__slogan',             { opacity: 1, x: 0, duration: 1.0, ease: 'power3.out' }, 0.2)
        .to('.hero__slogan-line',        { scaleX: 1, duration: 1.0, ease: 'power3.out' }, 0.35)
        .to('.hero__kicker',             { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }, 0.25)
        .to('.hero__title-word',         {
            yPercent: 0,
            opacity: 1,
            duration: 1.0,
            ease: 'expo.out',
            stagger: 0.16,
        }, 0.55)
        .to('.hero__title-accent',       { '--accent-scale': 1, duration: 1.0, ease: 'power3.out' }, 1.5)
        .to('.hero__title-sub',          { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }, 1.55)
        .to('.hero__right-panel',        { opacity: 1, x: 0, duration: 1.4, ease: 'power3.out' }, 1.7)
        .to('.hero__divider',            { opacity: 1, scaleX: 1, duration: 1.0, ease: 'power3.out' }, 1.9)
        .to('.hero__cta',                { opacity: 1, y: 0, duration: 1.0, ease: 'power3.out' }, 1.9)
        .to('.hero__stats',              { opacity: 1, x: 0, duration: 1.0, ease: 'power3.out' }, 2.0)
        .to('.hero__marquee',            { opacity: 1, y: 0, duration: 1.2, ease: 'power3.out' }, 2.3)
        .to('.hero__scroll',             { opacity: 1, duration: 1.0, ease: 'power2.out' }, 2.3);

      return tl;

      // ===== ANIMAÇÕES DE SCROLL =====
      // Criadas no onComplete da entrada — estado "from" garantidamente correto.
      function setupScrollAnimations() {

        // (sem bounce loop a parar — scroll-thumb é animação CSS)

        // ──────────────────────────────────────────────────────────────────────
        // MASTER TIMELINE — toda a transição hero → statement
        //
        // O hero fica PINADO por 4 viewports de scroll.
        // O ScrollTrigger faz o scrub dessa timeline ao longo desse range,
        // dando ao usuário controle total, como um dimmer de luz.
        //
        // Proporções da timeline (total ≈ 10 unidades arbitrárias):
        //   0.0 – 3.5  →  Fase 1: textos saem
        //   2.5 – 7.0  →  Fase 2: vídeo escurece (overlap = dimmer contínuo)
        //   6.5 – 10+  →  Fase 3: statement surge linha a linha
        // ──────────────────────────────────────────────────────────────────────
        var masterTl = gsap.timeline({
          defaults: { ease: 'none' }, // dimmer = linear por padrão
        });

        // FASE 1 — Textos somem (header no scroll: header.js + btn-show-menu, não scrub aqui)
        masterTl
          .to('.hero__scroll',      { opacity: 0, duration: 0.4 }, 0)
          .to('.hero__marquee',     { opacity: 0, y: 20, duration: 0.6 }, 0)
          .to(['.hero__slogan', '.hero__kicker', '.hero__title-sub', '.hero__divider', '.hero__cta'],
                                    { opacity: 0, y: -25, duration: 1.5 }, 0)
          .to('.hero__title-word',  { opacity: 0, y: -40, duration: 1.5 }, 0)
          .to('.hero__right-panel', { opacity: 0, duration: 1.0 }, 0)
          .to('.hero__stats',       { opacity: 0, x: 20, duration: 1.0 }, 0)

          // FASE 2 — Stage escurece até preto total
          .to('.hero__bg-video',    { opacity: 0, duration: 2.0 }, 1.0)
          .to('.hero__bg-video',    { scale: 1.18, duration: 3.2 }, 0)
          .to('.hero__overlay',     { opacity: 1, duration: 2.0 }, 1.0)

          // FASE 3 — Textos da statement surgem por cima, linha a linha
          // ease: power2.out em cada linha = entrada suave, elegante
          .to('.statement-line', {
            opacity: 1, y: 0,
            ease: 'power2.out',
            stagger: 0.55,
            duration: 1.3,
          }, 3.2)

          // FASE 4 — Textos saem em cascata reversa (última linha sai primeiro)
          .to('.statement-line', {
            opacity: 0, y: -25,
            ease: 'power2.in',
            stagger: { each: 0.55, from: 'end' },
            duration: 1.3,
          }, 6.3)

          // FASE 5 — Localização revela como novo cenário
          // autoAlpha: 1 → GSAP seta visibility:visible exatamente quando opacity começa a crescer
          .to('.location',       { autoAlpha: 1, duration: 1.0 }, 7.9)
          .to('.location__card', {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            ease: 'power3.out',
            duration: 2.4
          }, 11.0)
          .to('.location__terrain', {
            autoAlpha: 1,
            scale: 1,
            ease: 'power2.out',
            duration: 0.7
          }, 12.0)
          .to('#terrainPath', {
            strokeDashoffset: 0,
            ease: 'none',
            duration: 0.5
          }, 12.0)
          .to('.location__pin', {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            ease: 'back.out(1.8)',
            duration: 0.6
          }, 12.3)
          .to('.location__map-tag', {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            ease: 'back.out(1.6)',
            duration: 0.8
          }, 12.6)

          // FASE 6 — Saída da localização
          .to('.location__card', {
            autoAlpha: 0,
            y: -90,
            scale: 0.96,
            ease: 'power2.inOut',
            duration: 0.9
          }, IS_MOBILE ? 12.5 : 13.5)
          .to('.location__map-tag', {
            autoAlpha: 0,
            y: -16,
            scale: 0.9,
            ease: 'power2.in',
            duration: 0.6
          }, 13.45)
          .to('.location__pin', {
            autoAlpha: 0,
            y: -14,
            scale: 0.88,
            ease: 'power2.in',
            duration: 0.55
          }, 13.4)
          .to('.location__terrain', {
            autoAlpha: 0,
            y: -22,
            scale: 0.96,
            ease: 'power2.inOut',
            duration: 0.65
          }, 13.42)
          .to('.location', {
            autoAlpha: 0,
            duration: 0.9
          }, 13.95)

          // FASE 7 — Nova seção (bairro integrado)
          .to('.lifestyle', {
            autoAlpha: 1,
            duration: 1.0
          }, 14.15)
          .to('.lifestyle__bg-video', {
            scale: 1.04,
            duration: 3.85,
            ease: 'none'
          }, 14.15)
          .to('.lifestyle__title', {
            autoAlpha: 1,
            y: 0,
            ease: 'power3.out',
            duration: 1.1
          }, 18.25)
          .to('.lifestyle__description', {
            autoAlpha: 1,
            y: 0,
            ease: 'power3.out',
            duration: 1.0
          }, 18.5)
          .to('.lifestyle__highlights', {
            autoAlpha: 1,
            y: 0,
            ease: 'power3.out',
            duration: 0.9
          }, 18.7)

          // FASE 8 — Espaço (nova seção)
          // O branco "acende" suavemente por cima do lifestyle (expo.out = aceleração
          // inicial lenta que ganha força — mais elegante que linear ou power1).
          // A imagem sobe primeiro, sozinha; o conteúdo só começa 1.4s depois,
          // dando ritmo de coreografia entre os dois painéis.
          .to('.space', {
            autoAlpha: 1,
            ease: 'expo.out',
            duration: 1.8
          }, 19.8)
          .to('.space__image', IS_MOBILE
            ? { autoAlpha: 1, ease: 'power2.out', duration: 2.4 }
            : { y: 0, ease: 'power4.out', duration: 2.4 }
          , 20.75)
          .to('.space__content', IS_MOBILE
            ? { autoAlpha: 1, ease: 'power2.out', duration: 2.2 }
            : { y: 0, ease: 'power3.out', duration: 2.2 }
          , 21.9)
          .to('.space__vector', {
            autoAlpha: 1,
            scale: 1,
            ease: 'power2.out',
            duration: 1.2
          }, 22.7)
          .to('.space__vector path', {
            strokeDashoffset: 0,
            ease: 'none',
            duration: 1.8
          }, 22.7)
          .to('.space__title', {
            autoAlpha: 1,
            y: 0,
            ease: 'power3.out',
            duration: 1.0
          }, 22.9)
          .to('.space__text', {
            autoAlpha: 1,
            y: 0,
            ease: 'power3.out',
            stagger: 0.3,
            duration: 0.85
          }, 23.15)

          .to('.hero__white', {
            autoAlpha: 1,
            duration: 1.8,
            ease: 'power1.inOut'
          }, 25.4);

        // ── Fade-out do branco ao entrar na próxima seção ───────────────────
        // hero__white é position:fixed, então permanece sobre o viewport mesmo
        // após o hero despinar. Este ScrollTrigger dissolve o branco enquanto
        // #sobre sobe para o topo — sem revelar o hero rolando por baixo.
        gsap.to('.hero__white', {
          autoAlpha: 0,
          ease: 'none',
          scrollTrigger: home3ScrollCfg({
            trigger: '#sobre',
            start:   'top 95%',
            end:     'top 60%',
            scrub:   1,
            markers: false,
          })
        });

        ScrollTrigger.create(home3ScrollCfg({
          trigger: '#sobre',
          start: 'top top',
          end: 'bottom top',
          onEnter: function () {
            gsap.to('.hero__white', { autoAlpha: 0, duration: 0.25, overwrite: true });
          },
          onEnterBack: function () {
            gsap.to('.hero__white', { autoAlpha: 0, duration: 0.25, overwrite: true });
          }
        }));

        // Flag de estado — apenas para o hero video (play/pause ambient)
        var _heroVideoPaused = false;

        // Pina o hero — range ampliado para incluir a seção seguinte
        var heroPinST = ScrollTrigger.create(home3ScrollCfg({
          trigger:       '#hero',
          start:         'top top',
          end:           '+=1050%',
          pin:           true,
          pinSpacing:    true,
          anticipatePin: 1,
          scrub:         3,
          animation:     masterTl,

          onUpdate: function (self) {
            var p = self.progress;
            // Hero video: play/pause com hysteresis — é ambient, não scrubado
            if (p > 0.14 && !_heroVideoPaused) {
              if (heroVideo) heroVideo.pause();
              _heroVideoPaused = true;
            } else if (p < 0.10 && _heroVideoPaused) {
              if (heroVideo) heroVideo.play().catch(function () {});
              _heroVideoPaused = false;
            }
            // Location video: controlado pelo GSAP via masterTl (ver priming abaixo)
          },

          onLeave: function () {
            if (heroVideo) heroVideo.pause();
            if (locationVideo) locationVideo.pause();
            if (lifestyleVideo) lifestyleVideo.pause();
            if (spaceVideo) spaceVideo.pause();
            _heroVideoPaused = true;
          },

          // Reseta a flag para que o hysteresis do onUpdate funcione
          // corretamente quando o usuário volta para o hero
          onEnterBack: function () {
            _heroVideoPaused = false;
            if (heroVideo) heroVideo.play().catch(function () {});
          },
        }));

        // ── CTA "Explorar o projeto" → leva ao pico do reveal "Viver acima…"
        // A .statement vive dentro do hero pinado, então href="#statement"
        // cairia no topo do hero (errado). Calculamos o scroll a partir do
        // progresso da masterTl (timeline ≈ 6.2 = todas as 4 linhas visíveis,
        // pouco antes do fade-out começar em 6.3).
        var heroCtaBtn = document.querySelector('.hero__cta-btn');
        if (heroCtaBtn) {
          heroCtaBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var tlPos      = 6.2;
            var tlTotal    = masterTl.totalDuration() || 27.2;
            var progress   = Math.min(1, tlPos / tlTotal);
            var pinDist    = heroPinST.end - heroPinST.start;
            var targetY    = heroPinST.start + progress * pinDist;
            if (lenis && typeof lenis.scrollTo === 'function') {
              lenis.scrollTo(targetY, {
                duration: 1.6,
                easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
              });
            } else {
              window.scrollTo({ top: targetY, behavior: 'smooth' });
            }
          });
        }

        // ── Priming + scrub dos vídeos de scroll ─────────────────────────────
        // O preloader garantiu readyState >= 4 para todos os vídeos, então
        // duration já está disponível de forma síncrona. Adicionamos os tweens
        // ao masterTl imediatamente (antes do ScrollTrigger cachear a duração)
        // e chamamos play() só para desbloquear o seek — sem aguardar a Promise.
        function primeVideo(video, tlPosition, tlDuration) {
          if (!video) return;

          function addTween() {
            if (video.duration && isFinite(video.duration)) {
              masterTl.to(video, {
                currentTime: video.duration,
                ease:        'none',
                duration:    tlDuration,
              }, tlPosition);
            }
            // Desbloqueia seek: play imediato seguido de pause + reset
            video.play().then(function () {
              video.pause();
              video.currentTime = 0;
            }).catch(function () {});
          }

          if (video.readyState >= 1) {
            addTween();
          } else {
            video.addEventListener('loadedmetadata', addTween, { once: true });
          }
        }

        primeVideo(locationVideo,  7.9,   2.7);
        primeVideo(lifestyleVideo, 12.65, 3.85);
        primeVideo(spaceVideo,     21.65, 2.25);

        // ── Priming do vídeo de arquitetura (controlado pelo zoomTl) ─────────
        // Desbloqueia seek no browser: play imediato seguido de pause + reset.
        if (arquiteturaVideo) {
          arquiteturaVideo.play().then(function () {
            arquiteturaVideo.pause();
            arquiteturaVideo.currentTime = 0;
          }).catch(function () {});
        }

        // Notifica o ScrollTrigger sobre os novos tweens adicionados ao masterTl
        ScrollTrigger.refresh();

        // Header + btn-show-menu (paridade com AppHome): após sair do hero, remove inline
        // do GSAP da entrada para header.js (scrolled-up / scrolled-down) funcionar.
        ScrollTrigger.create(home3ScrollCfg({
          trigger: '#hero',
          start: 'bottom top',
          onEnter: function () {
            var header = document.getElementById('header');
            if (!header) return;
            gsap.set(header, { clearProps: 'transform,opacity' });
            gsap.set('#header .header-logo img', { clearProps: 'transform,opacity' });
            gsap.set('#header .nav-link', { clearProps: 'transform,opacity' });
            gsap.set('#header .social-icons', { clearProps: 'transform,opacity' });
          },
          onLeaveBack: function () {
            var header = document.getElementById('header');
            if (!header) return;
            header.classList.remove('scrolled-down', 'scrolled-up');
            gsap.set(header, { opacity: 1, clearProps: 'transform' });
            gsap.set('#header .header-logo img', { opacity: 1, scale: 1 });
            gsap.set('#header .nav-link', { opacity: 1, y: 0 });
            gsap.set('#header .social-icons', { opacity: 1, x: 0 });
          }
        }));

        // ── Seção SOBRE — entrada + saída dirigidas por scroll ──────────────────
        // Criada após ScrollTrigger.refresh() para que os pin spacers já existam
        // no DOM e as posições sejam calculadas corretamente.
        // Durações alinhadas com padrão das outras seções (stagger 0.55, duration 1.3+)
        var sobreTl = gsap.timeline();
        sobreTl
          .fromTo('#sobre .funciona-section__decoration', { autoAlpha: 0, y: 30 }, { autoAlpha: 1, y: 0, duration: 1.8, ease: 'power3.out' })
          .fromTo('#sobre .funciona-section__title', { autoAlpha: 0, y: 30 }, { autoAlpha: 1, y: 0, duration: 1.6, ease: 'power3.out' }, '-=1.2')
          .fromTo('#sobre .funciona-section__description', { autoAlpha: 0, y: 22 }, { autoAlpha: 1, y: 0, duration: 1.4, ease: 'power3.out' }, '-=1.0')
          .fromTo('#sobre .funciona-section__card', { autoAlpha: 0, y: 22 }, { autoAlpha: 1, y: 0, duration: 1.3, ease: 'power3.out', stagger: 0.55 }, '-=0.8')
          .fromTo('#sobre .funciona-section__btn', { autoAlpha: 0, y: 22 }, { autoAlpha: 1, y: 0, duration: 1.2, ease: 'power3.out' }, '-=0.5')
          .fromTo('#sobre .funciona-section__highlight', { autoAlpha: 0, y: 22 }, { autoAlpha: 1, y: 0, duration: 1.2, ease: 'power3.out' }, '-=0.9')
          .to({}, { duration: 2.5 })
          .to('#sobre .funciona-section__highlight', { autoAlpha: 0, y: -22, duration: 1.2, ease: 'power3.in' })
          .to('#sobre .funciona-section__btn', { autoAlpha: 0, y: -22, duration: 1.2, ease: 'power3.in' }, '-=0.9')
          .to('#sobre .funciona-section__card', { autoAlpha: 0, y: -22, duration: 1.3, ease: 'power3.in', stagger: { each: 0.55, from: 'end' } }, '-=0.6')
          .to('#sobre .funciona-section__description', { autoAlpha: 0, y: -22, duration: 1.4, ease: 'power3.in' }, '-=1.0')
          .to('#sobre .funciona-section__title', { autoAlpha: 0, y: -30, duration: 1.6, ease: 'power3.in' }, '-=1.2')
          .to('#sobre .funciona-section__decoration', { autoAlpha: 0, y: -30, duration: 1.8, ease: 'power3.in' }, '-=1.2');

        ScrollTrigger.create(home3ScrollCfg({
          trigger:   '#sobre',
          start:     'top 80%',
          end:       'bottom 20%',
          scrub:     true,
          animation: sobreTl,
        }));

        // ── Seção SILÊNCIO — viewBox zoom dirigido ao 'i' de "silêncio" ───────
        // Manipula o viewBox do SVG (não CSS scale) → zoom preciso no furo da letra.
        // Técnica: viewBox shrinks around FOCAL point; preserveAspectRatio slice
        // garante que a região visível sempre preencha o viewport.

        var maskSvg  = document.getElementById('mask-svg');
        var vbState  = { zoom: 1 };

        // Ponto focal = letra 'i' de "silêncio" no espaço viewBox 1000×1000.
        // Desktop: transform="translate(200,476) scale(1.031)" → x ≈ 625, y ≈ 482
        // Mobile (CSS): translate(230,476) scale(0.9279) — alinhado à frase reduzida
        var FOCAL_X = IS_MOBILE ? 612 : 625;
        var FOCAL_Y = 482;

        function applyViewBox(zoom) {
          var w = 1000 / zoom;
          var h = 1000 / zoom;
          // t=0 at zoom=1 (natural viewBox 0 0 1000 1000, text centered)
          // t→1 as zoom→∞ (centered on focal 'i'). Always moves in one direction.
          var t = 1 - (1 / zoom);
          var cx = 500 + (FOCAL_X - 500) * t;
          var cy = 500 + (FOCAL_Y - 500) * t;
          maskSvg.setAttribute('viewBox', (cx - w / 2) + ' ' + (cy - h / 2) + ' ' + w + ' ' + h);
        }

        applyViewBox(1); // estado inicial

        var zoomTl = gsap.timeline({
          onUpdate: function () { applyViewBox(vbState.zoom); }
        });
        zoomTl
          .to('.moving-content',     { y: 0, opacity: 1, duration: 1, ease: 'power2.out' })
          .to({}, { duration: 0.4 })
          .to('.text-group-visible', { opacity: 0, duration: 0.35, ease: 'none' })
          .to('.content-behind',     { opacity: 1, duration: 0.35, ease: 'none' }, '<')
          .to(vbState, { zoom: 800, ease: 'power2.in', duration: 3 })
          .to('.svg-mask-overlay',   { opacity: 0, duration: 0.5, ease: 'power1.out' }, '-=0.5')
          // Luxo text animations — após zoom completar
          .to('#silence .luxo__text', {
            opacity: 1,
            y: 0,
            ease: 'power3.out',
            duration: 1.2
          }, '-=0.3')
          .to('#silence .luxo__highlight', {
            opacity: 1,
            y: 0,
            ease: 'power3.out',
            duration: 1.0
          }, '-=0.6')
          // ── Escurece e revela arquitetura — tudo dentro do mesmo pin ──
          .to({}, { duration: 1.5 })
          .to('.luxo-pin__overlay',    { opacity: 0.85, duration: 1.5, ease: 'power2.in' })
          .to('.arquitetura__image', IS_MOBILE
            ? { autoAlpha: 1, ease: 'power2.out', duration: 2.4 }
            : { y: 0, ease: 'power4.out', duration: 2.4 }
          , '-=0.3')
          // Vídeo de arquitetura scrubado pelo scroll — duração real disponível pois preloader garantiu readyState >= 4
          .to(arquiteturaVideo, { currentTime: (arquiteturaVideo && arquiteturaVideo.duration) || 30, ease: 'none', duration: 2.4 }, '<')
          .to('.arquitetura__content', IS_MOBILE
            ? { autoAlpha: 1, ease: 'power2.out', duration: 2.2 }
            : { y: 0, ease: 'power3.out', duration: 2.2 }
          , '-=2.0')
          .to('.arquitetura__title',   { autoAlpha: 1, y: 0, ease: 'power3.out', duration: 1.0 }, '-=1.5')
          .to('.arquitetura__text',    { autoAlpha: 1, y: 0, stagger: 0.3, ease: 'power3.out', duration: 0.85 }, '-=0.8')
          .to('.arquitetura__logo',    { autoAlpha: 1, y: 0, stagger: 0.2, ease: 'power3.out', duration: 0.7 }, '-=0.5')
          .to({}, { duration: 1.5 }); // pausa final com arquitetura em foco

        ScrollTrigger.create(home3ScrollCfg({
          trigger:             '#silence',
          start:               'top top',
          end:                 IS_MOBILE ? '+=2500' : '+=4000',
          pin:                 true,
          pinSpacing:          true,
          anticipatePin:       1,
          scrub:               1.5,
          animation:           zoomTl,
          invalidateOnRefresh: true,
          onLeave:      function () {
            if (luxoVideo) luxoVideo.pause();
            if (arquiteturaVideo) arquiteturaVideo.pause();
          },
          onEnterBack:  function () {
            if (luxoVideo) luxoVideo.play().catch(function () {});
          },
        }));

        // ── Galeria — seção independente: pin + snap + parallax + drag ───────────
        var SLIDE_COUNT    = 3;
        var GALLERY_SCROLL = 2500;
        var galSection     = document.getElementById('galeria-section');
        var galViewport    = galSection ? galSection.querySelector('.galeria-section__viewport') : null;
        var galTrack       = galSection ? galSection.querySelector('.galeria__track') : null;
        var galSlideEls    = galSection ? Array.from(galSection.querySelectorAll('.galeria__slide')) : [];

        if (galViewport && galTrack && !IS_MOBILE) {
          // Timeline: duas transições lineares com label em cada slide
          var galTl = gsap.timeline();
          galTl
            .addLabel('slide-1', 0)
            .to(galTrack, { xPercent: -33.333, ease: 'none', duration: 1 })
            .addLabel('slide-2')
            .to(galTrack, { xPercent: -66.667, ease: 'none', duration: 1 })
            .addLabel('slide-3');

          var galST = ScrollTrigger.create(home3ScrollCfg({
            trigger:    galViewport,
            start:      'top top',
            end:        '+=' + GALLERY_SCROLL,
            pin:        true,
            pinSpacing: true,
            scrub:      0.6,          // resposta mais direta que o #silence (1.5)
            animation:  galTl,
            snap: {
              snapTo:   'labels',
              duration: { min: 0.3, max: 0.55 },
              ease:     'power2.inOut',
              delay:    0.08,
            },
            onUpdate: function (self) {
              var p = self.progress;
              // Parallax: media de cada slide desloca levemente na direção oposta ao track
              // range ±8% de xPercent (dentro da margem de 130% de largura do media)
              galSlideEls.forEach(function (slide, i) {
                var rel = p * (SLIDE_COUNT - 1) - i; // -1 → 0 → 1
                var el  = slide.querySelector('video, img');
                if (el) gsap.set(el, { xPercent: rel * 8 });
              });
              // Play/pause por visibilidade de slide
              galSlideEls.forEach(function (slide, i) {
                var vid     = slide.querySelector('video');
                if (!vid) return;
                var visible = Math.abs(p * (SLIDE_COUNT - 1) - i) < 1.0;
                if (visible) { vid.play().catch(function () {}); }
                else         { vid.pause(); }
              });
            },
            onLeave:     function () {},
            onEnterBack: function () {},
          }));

          // ── Drag para navegar na galeria ──────────────────────────────────────────
          // Arrastar 1 largura de tela = avançar 1 slide
          var _dragRatio  = GALLERY_SCROLL / (SLIDE_COUNT - 1) / window.innerWidth;
          var _dragStartX = 0, _dragStartScroll = 0, _dragging = false;

          galViewport.addEventListener('pointerdown', function (e) {
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            _dragging        = true;
            _dragStartX      = e.clientX;
            _dragStartScroll = window.scrollY;
            galViewport.setPointerCapture(e.pointerId);
            galViewport.classList.add('is-dragging');
            if (lenis) lenis.stop();
          });

          galViewport.addEventListener('pointermove', function (e) {
            if (!_dragging) return;
            var delta  = (_dragStartX - e.clientX) * _dragRatio;
            var target = Math.max(
              galST.start,
              Math.min(galST.start + GALLERY_SCROLL, _dragStartScroll + delta)
            );
            if (lenis) lenis.scrollTo(target, { immediate: true });
            else window.scrollTo(0, target);
          });

          function _endDrag() {
            if (!_dragging) return;
            _dragging = false;
            galViewport.classList.remove('is-dragging');
            if (lenis) lenis.start();
          }
          galViewport.addEventListener('pointerup',     _endDrag);
          galViewport.addEventListener('pointercancel', _endDrag);
        } else if (IS_MOBILE && galSlideEls.length) {
          // ── Mobile: galeria empilhada vertical com animação de entrada por slide ──
          galSlideEls.forEach(function (slide) {
            var titleEl = slide.querySelector(
              '.essencial-section__title, .permanecer-section__title, .rooftop-section__title'
            );
            var textEl = slide.querySelector(
              '.essencial-section__text, .permanecer-section__text, .rooftop-section__text'
            );

            if (titleEl) gsap.set(titleEl, { autoAlpha: 0, y: 30 });
            if (textEl)  gsap.set(textEl,  { autoAlpha: 0, y: 25 });

            var slideTl = gsap.timeline();
            if (titleEl) slideTl.to(titleEl, { autoAlpha: 1, y: 0, duration: 0.8, ease: 'power3.out' });
            if (textEl)  slideTl.to(textEl,  { autoAlpha: 1, y: 0, duration: 0.7, ease: 'power3.out' }, '-=0.4');

            ScrollTrigger.create(home3ScrollCfg({
              trigger:   slide,
              start:     'top 70%',
              end:       'top 30%',
              scrub:     true,
              animation: slideTl,
            }));

            var vid = slide.querySelector('video');
            if (vid) {
              var obs = new IntersectionObserver(function (entries) {
                if (entries[0].isIntersecting) vid.play().catch(function () {});
                else vid.pause();
              }, { threshold: 0.3 });
              obs.observe(slide);
            }
          });
        }

        // ── Towers Section — fade in do mapa + nav items ──────────────────────
        var towersSection = document.querySelector('.towers-section');
        var towersMap     = document.querySelector('.towers-map-container');
        var towersNavItems = document.querySelectorAll('.towers-nav__item');

        if (towersSection && towersMap) {
          var towersTl = gsap.timeline();
          towersTl.to(towersMap, { autoAlpha: 1, duration: 1.0, ease: 'power2.out' });
          if (towersNavItems.length) {
            towersTl.to(towersNavItems, { autoAlpha: 1, y: 0, duration: 0.6, ease: 'power3.out', stagger: 0.08 }, '-=0.4');
          }

          ScrollTrigger.create(home3ScrollCfg({
            trigger:   towersSection,
            start:     'top 80%',
            end:       'top 50%',
            scrub:     true,
            animation: towersTl,
          }));
        }

        // ── Produtos Home (desktop) — mapa interativo estilo página de produto ──
        setupProdutosHome();

      } // fim setupScrollAnimations

      // Mapa interativo de produtos no estilo do produto-detail-desk, agora na home (desktop).
      // Sincroniza tabs ↔ áreas do SVG ↔ background; CTA ocultado para "rooftop".
      function setupProdutosHome() {
        var prod = document.querySelector('.produtos-home.produtos');
        if (!prod) return;

        var tabs = prod.querySelectorAll('.produtos__tab');
        var bgs = prod.querySelectorAll('.produtos__bg');
        var para = prod.querySelector('#prod-para-home');
        var desc = prod.querySelector('#prod-desc-home');
        var link = prod.querySelector('#prod-link-home');
        var mapAreas = prod.querySelectorAll('.map-area-predios');

        var data = {};
        tabs.forEach(function (tab) {
          data[tab.dataset.prod] = {
            para: tab.dataset.para || '',
            title: tab.dataset.title || '',
            desc: tab.dataset.desc || '',
            link: tab.dataset.href || '#'
          };
        });

        var hasGsap = typeof gsap !== 'undefined';
        var elements = [para, desc, link].filter(Boolean);
        if (hasGsap && elements.length) {
          gsap.set(elements, { autoAlpha: 0, y: 30 });
        }

        var pinned = 'default';

        function update(key) {
          tabs.forEach(function (t) {
            t.classList.toggle('is-active', t.dataset.prod === key && key !== 'default');
          });
          bgs.forEach(function (bg) {
            bg.classList.remove('is-hover');
            bg.classList.toggle('is-active', bg.dataset.prod === key);
          });

          if (!hasGsap) {
            if (data[key]) {
              if (para) para.innerHTML = data[key].para;
              if (desc) desc.innerHTML = data[key].desc;
              if (link) {
                link.href = data[key].link;
                link.classList.remove('produtos__cta--hidden');
              }
            } else {
              if (para) para.innerHTML = '';
              if (desc) desc.innerHTML = '';
            }
            return;
          }

          gsap.killTweensOf(elements);
          if (data[key]) {
            gsap.to(elements, {
              autoAlpha: 0, y: -20, duration: 0.3, ease: 'power2.in',
              onComplete: function () {
                if (para) para.innerHTML = data[key].para;
                if (desc) desc.innerHTML = data[key].desc;
                if (link) link.href = data[key].link;
                gsap.set(elements, { y: 30, autoAlpha: 0 });
                if (key === 'rooftop' && link) {
                  // Classe --hidden com !important evita estado preso por GSAP race
                  link.classList.add('produtos__cta--hidden');
                  gsap.set(link, { autoAlpha: 0, pointerEvents: 'none' });
                } else if (link) {
                  link.classList.remove('produtos__cta--hidden');
                  gsap.set(link, { pointerEvents: 'auto' });
                }
                gsap.to(elements, {
                  autoAlpha: function (i, el) { return (el === link && key === 'rooftop') ? 0 : 1; },
                  y: 0, duration: 0.8, ease: 'expo.out', stagger: 0.1, clearProps: 'transform'
                });
              }
            });
          } else {
            // Classe --hidden tem !important no CSS — vence qualquer inline-style
            // que o GSAP tenha deixado preso (opacity:1, visibility:inherit) por
            // tween de autoAlpha morto mid-flight. Class é fonte da verdade aqui.
            if (link) link.classList.add('produtos__cta--hidden');
            gsap.to(elements, {
              autoAlpha: 0, y: -20, duration: 0.4, ease: 'power2.in',
              onComplete: function () {
                if (para) para.innerHTML = '';
                if (desc) desc.innerHTML = '';
              }
            });
          }
        }

        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            var key = tab.dataset.prod;
            pinned = (key === pinned) ? 'default' : key;
            update(pinned);
          });
        });

        var setHoverPreview = function (key) {
          bgs.forEach(function (bg) {
            var isPinned = bg.classList.contains('is-active');
            bg.classList.toggle('is-hover', !isPinned && bg.dataset.prod === key);
          });
        };

        var clearHoverPreview = function () {
          bgs.forEach(function (bg) { bg.classList.remove('is-hover'); });
        };

        mapAreas.forEach(function (area) {
          area.addEventListener('mouseenter', function () { setHoverPreview(area.dataset.id); });
          area.addEventListener('mouseleave', clearHoverPreview);
          area.addEventListener('click', function (e) {
            e.preventDefault();
            var key = area.dataset.id;
            pinned = (key === pinned) ? 'default' : key;
            update(pinned);
            clearHoverPreview();
          });
        });
      }

      } // fim initApp

      function preloadAssets() {
        // Vídeo scrub: fetch + blob (igual AppHome) — seek em currentTime com GSAP falha em MP4 só progressivo.
        var arquiteturaVideo = document.getElementById('arquiteturaVideo');
        if (arquiteturaVideo && arquiteturaVideo.getAttribute('src') && !arquiteturaVideo._blobLoaded) {
          fetch(arquiteturaVideo.getAttribute('src'))
            .then(function (r) { return r.blob(); })
            .then(function (blob) {
              arquiteturaVideo.setAttribute('src', URL.createObjectURL(blob));
              arquiteturaVideo._blobLoaded = true;
            })
            .catch(function () {})
            .then(function () { runPreloadQueue(); });
          return;
        }
        runPreloadQueue();
        function runPreloadQueue() {
        var resources = Array.from(document.querySelectorAll('#home3 video, #home3 img')).filter(function (el) {
          if (el.closest('.home3-tail-below')) return false;
          if (el.closest('.essencial-section') || el.closest('.permanecer-section') || el.closest('.rooftop-section')) return false;
          // Vídeo do luxo: só recebe src após initApp (data-src); não bloquear o preloader
          if (el.closest('.luxo')) return false;
          return true;
        });
        var total = resources.length;
        var loaded = 0;

        if (total === 0) {
          revealPage();
          return;
        }

        function update(resource) {
          loaded++;
          setProgress(loaded, total);
          if (resource) {
            console.log('Preloader: resource loaded ->', resource.src || resource.currentSrc || resource.href || resource.srcset || resource);
          }
          if (loaded >= total) {
            var heroVid = document.getElementById('heroVideo');
            var heroOverlay = document.querySelector('.hero__overlay');

            if (heroVid) {
              heroVid.play().then(function() {
                // Double rAF ensures first decoded frame is composited on screen
                requestAnimationFrame(function() {
                  requestAnimationFrame(function() {
                    heroVid.style.opacity = '1';
                    if (heroOverlay) heroOverlay.style.opacity = '1';
                    revealPage();
                  });
                });
              }).catch(function() {
                // Autoplay blocked - reveal anyway so user isn't stuck
                heroVid.style.opacity = '1';
                if (heroOverlay) heroOverlay.style.opacity = '1';
                revealPage();
              });
            } else {
              if (heroOverlay) heroOverlay.style.opacity = '1';
              revealPage();
            }
          }
        }

        function onError(resource) {
          console.warn('Preloader: resource failed ->', resource && (resource.src || resource.currentSrc || resource.href || resource.srcset || resource));
          update(resource);
        }

        setProgress(0, total);

        resources.forEach(function (resource) {
          var tag = resource.tagName.toLowerCase();

          if (tag === 'video') {
            // Para scrub suave precisamos de canplaythrough (dados bufferizados),
            // não apenas loadedmetadata (só metadados). Fallback após 20s caso
            // o vídeo demore demais (ex: conexão lenta ou arquivo sem faststart).
            var _done = false;
            var _timer = setTimeout(function () {
              if (!_done) {
                _done = true;
                console.warn('Preloader: video canplaythrough timeout ->', resource.src);
                update(resource);
              }
            }, 20000);
            var _onReady = function () {
              if (!_done) { _done = true; clearTimeout(_timer); update(resource); }
            };
            var _onErr = function () {
              if (!_done) { _done = true; clearTimeout(_timer); onError(resource); }
            };
            if (resource.readyState >= 4) {
              _done = true; clearTimeout(_timer); update(resource);
            } else {
              resource.addEventListener('canplaythrough', _onReady, { once: true });
              resource.addEventListener('error', _onErr, { once: true });
              try { resource.load(); } catch (e) { _onErr(); }
            }
          } else {
            if (resource.complete && resource.naturalWidth !== 0) {
              update(resource);
            } else {
              resource.addEventListener('load', function () { update(resource); }, { once: true });
              resource.addEventListener('error', function () { onError(resource); }, { once: true });
            }
          }
        });
        }
      }

      preloadAssets();

    });
